import type { Role } from '@/types';

/** Payments Ledger access (story 103704): Admin, Super Admin, Operational Associate.
 *  Dealer + Field Installer denied. Mirrors ORDERS_ROLES. */
export const PAYMENTS_ROLES: Role[] = ['super_admin', 'admin', 'operational_associate'];

/** Human page name for the access-denied toast (ADR-0014). */
export const PAYMENTS_PAGE_NAME = 'Payments';
